import { gql } from '@apollo/client';
import type * as Types from './Types';

export type BaseUserFragment = { _id: string; email: string; admin: boolean };

export const BaseUserFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseUser on User {
    _id
    email
    admin
  }
`;
